module.exports = __webpack_public_path__ + "static/media/on-demand-reflexology.ad9db6f9.svg";